import React, { useEffect, useState } from 'react'
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import NormalSelect from '../form/HorizontalNormalSelect';
import { use } from 'react';
import { problemType } from '../../api';
import NormalInput from "../form/HorizontalNormalInput";

export const DynamicProblemTypeForm = ({
  onChange,
  onNoteChange,
  selectedProblemTypePrev = [],
  defaultNote = null,
}) => {
  const { config, setConfig } = useAuth();
  const [problemTypeWording, setProblemTypeWording] = useState([]);
  const [grouped, setGrouped] = useState([[]]);
  const [selectedProblemType, setSelectedProblemType] = useState([]);
  const [openNote, setOpenNote] = useState(false);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (config) {
      initFirstGroup();
      setProblemTypeWording(config.problem_type_wording.split(","));
    }
  }, [config]);

  const initFirstGroup = async () => {
    const data = await getProblemType();
    const initialGrouped = [data];
    const processAll = [];
    for (let i = 0; i < selectedProblemTypePrev.length; i++) {
      const process = getProblemType(selectedProblemTypePrev[i]);
      processAll.push(process);
    }
    const datas = await Promise.all(processAll);
    initialGrouped.push(...datas);
    setGrouped(initialGrouped);
    setSelectedProblemType(selectedProblemTypePrev);
    setNote(defaultNote || "");
  };

  async function getProblemType(parentId = "root") {
    try {
      setLoading(true);
      const res = await problemType.list(parentId, "");
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        return data;
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  const handleProblemTypeChange = async (e, index) => {
    const newSelectedProblemType = [...selectedProblemType];
    newSelectedProblemType[index] = e.target.value;
    for (let i = index + 1; i < newSelectedProblemType.length; i++) {
      newSelectedProblemType[i] = "";
    }
    setSelectedProblemType(newSelectedProblemType);

    const populatedIndex = index + 1;
    const data = await getProblemType(e.target.value || "none");
    const copyGrouped = [...grouped];
    copyGrouped[populatedIndex] = data;

    for (let i = populatedIndex + 1; i < copyGrouped.length; i++) {
      copyGrouped[i] = [];
    }
    setGrouped(copyGrouped);

    const cleanedSelected = newSelectedProblemType.filter(
      (problemType) => problemType !== ""
    );
    const latestSelected =
      cleanedSelected.length > 0
        ? cleanedSelected[cleanedSelected.length - 1]
        : null;
    let detailSelected = null;
    for (let i = 0; i < copyGrouped.length; i++) {
      const found = copyGrouped[i].find(
        (problemType) => problemType.id === latestSelected
      );
      if (found) {
        detailSelected = found;
        break;
      }
    }
    onChange(detailSelected, cleanedSelected);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
    onNoteChange(e.target.value);
  };

  useEffect(() => {
    if (
      selectedProblemType.length == 4 &&
      selectedProblemType[selectedProblemType.length - 1]
    ) {
      const latestSelected =
        selectedProblemType[selectedProblemType.length - 1];
      let detailSelected = null;
      const copyGrouped = [...grouped];
      for (let i = 0; i < copyGrouped.length; i++) {
        const found = copyGrouped[i].find(
          (problemType) => problemType.id === latestSelected
        );
        if (found) {
          detailSelected = found;
          break;
        }
      }
      if (
        detailSelected &&
        detailSelected.problem_type_name.toLowerCase().includes("other")
      ) {
        setOpenNote(true);
      } else {
        setOpenNote(false);
        setNote("");
        onNoteChange("");
      }
    } else {
      setOpenNote(false);
      setNote("");
      onNoteChange("");
    }
  }, [selectedProblemType]);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
          style={{
            height: 200,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="spinner-grow text-theme"></div>
        </div>
      )}
      {problemTypeWording.map((wording, index) => {
        return (
          <div key={index}>
            <NormalSelect
              key={index}
              value={selectedProblemType[index]}
              label={wording}
              onchange={(e) => handleProblemTypeChange(e, index)}
              list={grouped[index] || []}
              name={`problem_type_id`}
              valueKey="id"
              textKey="problem_type_name"
            />
          </div>
        );
      })}

      {openNote && (
        <div className="mt-2">
          <NormalInput
            value={note}
            onchange={(e) => handleNoteChange(e)}
            label="Note"
          />
        </div>
      )}
    </>
  );
};
